/**
 * Events
 * ------
 */




if($('#tribe-bar-filters-wrap').length) {

    let dateInput = $('#tribe-bar-date'),
        searchInput = $('#tribe-events-events-bar-keyword'),
        eventsSearchSubmit = $('#events-submit-search'),
        keywordSearchToggle = $('.keyword-search-toggle'),
        keywordSearchContents = $('.keyword-search-contents'),
        keywordSearchContainer = $('.tribe-bar-search-filter');

    dateInput.on('update change', function () {
        eventsSearchSubmit.click();
    });

    searchInput.on('update change', function () {
        eventsSearchSubmit.click();
    });

    if(searchInput.val() !== "") {
        keywordSearchContents.removeClass('hiding');
        keywordSearchContainer.addClass('open');
    }

    searchInput.on('focusout', function () {
        if(searchInput.val() === "") {
            keywordSearchContents.addClass('hiding');
            keywordSearchContainer.removeClass('open');
        }
    });

    keywordSearchToggle.on('click', function (e) {
        if(keywordSearchContents.hasClass('hiding')) {
            if ($(window).width() > 992) {
                e.preventDefault();
            }
            keywordSearchContents.removeClass('hiding');
            keywordSearchContainer.addClass('open');
            searchInput.focus();
        }
    });

    let previousButton = $('.tribe-events-nav-previous a'),
        nextButton = $('.tribe-events-nav-next a');

    // if(previousButton.length) previousButton.html('Previous');
    // if(nextButton.length) nextButton.html('Next');

}